/* RESPONSIBLE TEAM: team-fin-voice */
/* eslint-disable @intercom/intercom/no-bare-strings */

export type FinVoicePipelineOptions = {
  value: FinVoicePipeline;
  text: string;
};

export type FinVoicePipeline =
  | 'default'
  | 'realtime-frontline-agent-experimental-v1'
  | 'realtime-conversation-plan-v1'
  | 'realtime-sdr-v1';

export const FIN_VOICE_PIPELINE_OPTIONS: FinVoicePipelineOptions[] = [
  { value: 'default', text: 'Default' },
  {
    value: 'realtime-frontline-agent-experimental-v1',
    text: 'Realtime Frontline Agent Experimental v1',
  },
  {
    value: 'realtime-conversation-plan-v1',
    text: 'Realtime Conversation Plan v1',
  },
  {
    value: 'realtime-sdr-v1',
    text: 'Realtime SDR v1',
  },
];
